// extracted by css-extract-rspack-plugin
export default {"button":"_7d183624","arrow":"_f9c8358b","isHidden":"_cdb37022","arrowLeft":"_e11c9170","arrowRight":"_b0c8476b","hideScrollbar":"_e15dd72e"};